<template>
  <div class="goods">
    <!--<van-nav-bar title="爱车估值" left-arrow @click-left="onClickLeft" style="height: 1.28rem"/>-->

    <div class="flex-start" style="height: 1.998rem;padding-right: .405rem;border-bottom: .324rem solid #F2F2F2;background: #fff">
      <!--<van-icon name="star-o" size=".729rem" style="padding: 0 .405rem;"/>-->
        <img :src="detail.brandLogo" alt="" style="width: 1rem;height: 1rem;margin: .3rem;">
      <div style="line-height: .6rem">
        <div class="ellipsis-1" style="font-size: .378rem;color: #333;width: 8rem">{{detail.carModel}}</div>
        <div style="font-size: .297rem;color: #999">{{detail.registrationTime}}/{{detail.mileage}}万公里/{{detail.sellCarCity}} </div>
      </div>
    </div>

    <div style="border-bottom: .324rem solid #F2F2F2;background: #fff;">
        <van-tabs v-model="activeName">
            <van-tab v-bind:title="item.title" v-bind:name="item.name" v-for="item,index in activeMain">
                <div v-if="item.price!=''" style="height: 2.65rem;text-align: center;border-top: 1px solid #E9E9E9;">
                    <div style="font-size: .75rem;color: #e9081a;margin: .75rem 0 .3rem;line-height: .55rem;">{{item.price}}</div>
                    <div style="font-size: .3rem;color: #999;line-height: .3rem">估价仅供参考，最终价格以实际评估结果为准</div>
                </div>
                <div v-else style="height: 2.65rem;text-align: center;border-top: 1px solid #E9E9E9;color: #F7932B;font-size: .42667rem;line-height: .534rem;">
                    <div style="margin: .8rem 0 0;">该车型暂无报价</div>
                    <div>稍后客服将联系您，给您精准的报价</div>
                </div>
            </van-tab>
        </van-tabs>
    </div>

      <div style="background: #fff;text-align: center">
          <div class="flex-center">
              <div style="background: #E9E9E9;height: 1px;width: .574rem"></div>
              <div style="font-size: .432rem;color: #333;margin: .54rem .378rem .378rem">卖车小流程</div>
              <div style="background: #E9E9E9;height: 1px;width: .574rem"></div>
          </div>
          <div style="font-size: .351rem;color: #999;padding-bottom: .297rem">快速高价，正规平台安全放心 </div>
      </div>
    <div class="flex-start" style="padding: 0 .405rem;font-size: .351rem;color: #333;background: #fff">
      <van-col span="6" v-for="item,index in goods.list" class="flex-column" style="height: 2.7rem;position: relative">
        <!--<van-icon v-bind:name="item.icon" size=".684rem" style="margin-bottom: .459rem"/>-->
         <img v-bind:src="item.icon" alt="" style="width: 0.667rem;margin-bottom: .5rem;">
        <div>
          {{item.name}}
          <!--<van-icon v-if="index !=3" name="arrow" size=".351rem" style="position: absolute;right: -.18rem;top: .8rem;"/>-->
            <img v-if="index !=3" src="../../image/triangle.png" alt="" style="position: absolute;right: -0.1rem;top: 0.8rem;width: .2rem;">
        </div>
      </van-col>
    </div>

    <div class="flex-center" style="width: 100%;margin-top: 1.242rem">
      <div class="flex-center" style="background: #e9081a;color: #fff;font-size: .432rem;width: 90%;height: 1.188rem;border-radius: .594rem;" @click="toPublish">快速卖车</div>
    </div>

  </div>
</template>

<script>
    import {
        NavBar,
        Col,
        Icon,
        Tab,
        Tabs
    } from 'vant';

    import index1 from '../../image/index1.png'; // import 引入图片
    import index2 from '../../image/index5.png';
    import index3 from '../../image/index3.png';
    import index4 from '../../image/index4.png';

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs
        },

        data() {
            return {
                goods: {
                    list:[
                        {name:"填写信息",icon:index1},
                        {name:"评估师回访",icon:index2},
                        {name:"到4S店评估",icon:index3},
                        {name:"签约付款",icon:index4}
                    ]
                },
                activeName: 'a',
                activeMain:[
                    {title:"估价范围",name:"a",price:""}
                ],
                detail:""
            };
        },

        methods: {
            toPublish() {

                //console.log(this.$store.state.token)
                /*if(this.$store.state.token == undefined){
                    wx.miniProgram.switchTab({
                        url: '/pages/main/member/index'//小程序链接会员中心
                    });
                    return false;
                }*/

                let detail=this.$route.query.detail;
                this.$router.push({ path: '/Collect/Publish', query: { detail:detail }})
                //this.$router.push('/Collect/Publish');
                console.log(detail)
            },
            onClickLeft() {
                this.$router.push('/Collect');
            }
        },
        mounted: function () {
            //console.log("Key-mounted")
            var _this = this;
            var detail = JSON.parse(_this.$route.query.detail);
            //console.log(detail,"数据",detail.valuationDetail)
            detail.registrationTime=new Date(detail.registrationTime).getFullYear()+'年'+(new Date(detail.registrationTime).getMonth()+1)+'月'+new Date(detail.registrationTime).getDate() ;
            _this.detail=detail;
            _this.activeMain[0].price=detail.valuationDetail;
            //console.log(detail,_this.$route.query.detail)
        }
    };
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;

    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }

    &-title {
      font-size: 16px;
    }

    &-price {
      color: #f44;
    }

    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }

    &-cell-group {
      margin: 15px 0;

      .van-cell__value {
        color: #999;
      }
    }

    &-tag {
      margin-left: 5px;
    }
  }

  body{
    background: #F2F2F2;
  }
  .flex-start{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:flex-start;
  }
  .flex-center{
    display:flex;
    flex-direction: row;
    align-items:center;
    justify-content:center;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .van-nav-bar__title{
      font-size: .486rem;
      color: #333;
  }
  .van-nav-bar .van-icon{
      font-size: .486rem;
      color: #333;
  }
  .ellipsis-1{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
  }
  .van-tabs__line{
      width: .7rem!important;
      display: none;
  }
  .van-ellipsis{
      font-size: 0.42667rem;
      font-weight: bold;
  }
</style>
